import { create } from "axios";

import { env } from "../utils/env";

export const axiosInstance = create({
  baseURL: env.REACT_APP_BACKEND_URL,
});
